import { useTranslation } from 'react-i18next';

import { useRepository } from '../../data/RepositoryProvider';
import { SensitiveActionDialog } from '../../shared/actions/SensitiveActionDialog';
import { walletsRepositoryToken } from './repository';
import type { WalletDetail } from './types';

export function WalletStatusDialog({
  onClose,
  onSaved,
  open,
  wallet,
}: {
  readonly onClose: () => void;
  readonly onSaved: (wallet: WalletDetail) => void;
  readonly open: boolean;
  readonly wallet: WalletDetail;
}) {
  const { t } = useTranslation();
  const repository = useRepository(walletsRepositoryToken);
  const targetStatus = wallet.status === 'ACTIVE' ? 'SUSPENDED' : 'ACTIVE';
  const suspending = targetStatus === 'SUSPENDED';

  return (
    <SensitiveActionDialog
      impact={
        suspending
          ? t('wallets.status.suspendImpact', {
              current: wallet.status,
              proposed: targetStatus,
              wallet: wallet.id,
            })
          : t('wallets.status.reactivateImpact', {
              current: wallet.status,
              proposed: targetStatus,
              wallet: wallet.id,
            })
      }
      onClose={onClose}
      onConfirm={async ({ reason }) => {
        const result = await repository.changeStatus(wallet.id, { status: targetStatus, reason });
        onSaved(result.data);
      }}
      open={open}
      requireEvidence={false}
      showEvidence={false}
      title={
        suspending ? t('wallets.actions.suspendWallet') : t('wallets.actions.reactivateWallet')
      }
    />
  );
}
